module.exports = __webpack_public_path__ + "img/08—01—04—Diagnostic information > Telephony > Signal Feedback.f6943657.jpg";